import ApiKeyTable from "@/app/app-shared/api-key/table";
import { useTableServer } from "@/hooks/useTableServer";
import APIKeyRepository from "@/utilities/repositories/ApiKey";
import { useMemo } from "react";
import { Roles } from "@/utilities/types/Users";
import { useColumn } from "@/hooks/use-column";
import { GetColumns } from "@/app/app-shared/api-key/table/columns";
import useApi from "@/hooks/useApi";
import toast from "react-hot-toast";
import { useModal } from "@/app/shared/modal-views/use-modal";
import { CreateEditApiKey } from "@/app/app-shared/api-key/create-edit/create-edit-api-key";
import ControlledTable from "@/components/controlled-table";

export default function ApiKeyWrapper() {
  const {
    handleReset,
    isLoading,
    tableData,
    currentPage,
    totalItems,
    handleSort,
    handlePaginate,
    pageSize,
    handleChangePageSize,
  } = useTableServer({
    server: {
      request: APIKeyRepository.getAPIKey,
    },
  });

  const { request: deleteApiKey } = useApi({
    request: APIKeyRepository.deleteApiKey,
  });
  const { openModal } = useModal();

  const onHeaderCellClick = (value: string) => ({
    onClick: () => {
      handleSort(value);
    },
  });

  const onDeleteItem = async (id: string) => {
    try {
      await deleteApiKey(id);
      toast.success("Delete Api key success!");
      handleReset();
    } catch (err) {
      console.log(err);
      toast.error("Delete API key failed");
    }
  };
  
  const onEditItem = (row: any) => {
    openModal({
      view: (
        <CreateEditApiKey
          refetchData={() => handlePaginate(currentPage)}
          row={row}
        />
      ),
      customSize: "600px",
    });
  };

  const columns = useMemo(
    () =>
      GetColumns({
        data: tableData,
        onDeleteItem,
        onHeaderCellClick,
        reset: handleReset,
        role: Roles.ADMIN,
        onEditItem,
      }),
    [onHeaderCellClick, onDeleteItem, tableData, onEditItem, handleReset]
  );

  const { visibleColumns } = useColumn(columns);

  return (
    <div>
      <ControlledTable
        variant="modern"
        data={tableData}
        isLoading={isLoading}
        showLoadingText={true}
        // @ts-ignore
        columns={visibleColumns}
        paginatorOptions={{
          pageSize,
          setPageSize: handleChangePageSize,
          total: totalItems,
          current: currentPage,
          onChange: (page: number) => handlePaginate(page),
        }}
        className="rounded-md border border-muted text-sm shadow-sm [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:h-60 [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:justify-center [&_.rc-table-row:last-child_td.rc-table-cell]:border-b-0 [&_thead.rc-table-thead]:border-t-0"
      />
    </div>
  );
}